import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  url = `${environment.host}/api/foto`;

  constructor(
    private http: HttpClient
  ) { }
  private usuarioNombrePerfilSource = new BehaviorSubject<string>('');
  currentUsuarioNombrePerfil = this.usuarioNombrePerfilSource.asObservable();

  public cambiarUsuarioNombrePerfil(texto: string) {
    this.usuarioNombrePerfilSource.next(texto);
  }

  public obtenerValorActual(): string {
    return this.usuarioNombrePerfilSource.value;
  }

  /** Reinicia el nombre de perfil al cerrar sesión */
  reset() {
    this.usuarioNombrePerfilSource.next('');
  }
}
